export default __webpack_public_path__ + "static/media/img-07.5dbd25de.jpg";